<div class="right-side p-3">
  <h2>Proposal Details</h2>
  <div class="row justify-content-end mb-1">
    <div class="col-lg-8" *ngIf="isProposalStatusMessageHidden">
      <h3 *ngIf="IsProposalStatus" id="txtCreateProposal" style="color: red; float: right">Please fill in the Organizational Information from your Profile.*</h3>
    </div>
    <div class="col-lg-4 col-sm-6 text-end">
      <button type="button" (click)="NewProposal()" class="btn btn-primary btn-sm mb-2 me-2" [disabled]="IsProposalStatus">
        Create Proposal
      </button>
    </div>
  </div>
  <div class="section">
    <form [formGroup]="iaProposalForm">
      <div class="row">
        <div class="search">


          <div class="row">
            <!--<mat-card-content class="p-24">

            </mat-card-content>-->
            <div class="text-end">
              <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2"><i class="bi bi-file-earmark-excel"></i> Export To Excel</button>
            </div>
            <div class="col-lg-7 col-sm-12">
              <div class="search-container">
                <mat-form-field class="search-input w-75" appearance="outline">
                  <mat-label>Search</mat-label>
                  <input matInput formControlName="search" />
                </mat-form-field>
                <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(iaProposalForm.get('search')?.value ?? '')" id="btnSearch">
                  <i class="bi bi-search fs-4"></i>
                </button>
                <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
                  <i class="bi bi-arrow-clockwise fs-4"></i>
                </button>
              </div>
              <div *ngIf="iaProposalForm.get('search')?.invalid && (iaProposalForm.get('search')?.touched || iaProposalForm.get('search')?.dirty)">
                <small *ngIf="iaProposalForm.get('search')?.errors?.['pattern']" class="text-danger">
                  Invalid search term.
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table mat-table [dataSource]="dataMySource" matSort class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="dateofSubmission" matSortDirection="desc" matSortDisableClear>
            <ng-container matColumnDef="Sr.No">
              <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
              <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
            </ng-container>
            <!--<ng-container matColumnDef="createdProposalId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal Id</th>
    <td mat-cell *matCellDef="let el"> {{el.createdProposalId}} </td>
  </ng-container>-->
            <ng-container matColumnDef="createdProposalId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal Id</th>
              <td mat-cell *matCellDef="let el">
                <a (click)="onViewProposal(el.proposalUserId,'view')" class="text-primary no-underline" style="cursor: pointer;">
                  {{el.createdProposalId}}
                </a>
              </td>
            </ng-container>


            <ng-container matColumnDef="proposalId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Proposal Id</th>
              <td mat-cell *matCellDef="let el"> {{el.proposalId}} </td>
            </ng-container>
            <ng-container matColumnDef="shortNameOfOrganisation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>IA Short Name</th>
              <td mat-cell *matCellDef="let el"> {{el.shortNameOfOrganisation}} </td>
            </ng-container>
            <ng-container matColumnDef="dateofSubmission">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Submission Date</th>
              <td mat-cell *matCellDef="let el"> {{el.dateofSubmission}} </td>
            </ng-container>
            <ng-container matColumnDef="interventionName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Intervention</th>
              <td mat-cell *matCellDef="let el"> {{el.interventionName}} </td>
            </ng-container>
            <ng-container matColumnDef="componentName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Component</th>
              <td mat-cell *matCellDef="let el"> {{el.componentName}} </td>
            </ng-container>
            <!--added by rp-->
            <ng-container matColumnDef="targetMSME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Target MSME</th>
              <td mat-cell *matCellDef="let el"> {{el.targetMSME}} </td>
            </ng-container>
            <ng-container matColumnDef="approvedTargetMSME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Approved Target MSME</th>
              <td mat-cell *matCellDef="let el"> {{el.approvedTargetMSME}} </td>
            </ng-container>
            <ng-container matColumnDef="balanceTargetMSME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Balance Target MSME</th>
              <td mat-cell *matCellDef="let el"> {{el.balanceTargetMSME}} </td>
            </ng-container>
            <!--rp ends-->
            <ng-container matColumnDef="totalEventCount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Event</th>
              <td mat-cell *matCellDef="let el"> {{el.totalEventCount}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let el">
                {{el.status}}

                <ng-container *ngIf="el.status === 'Approved'">
                  <button (click)="onViewProposal(el.proposalUserId,'view')" class="btn btn-primary btn-sm">
                    <i class="bi bi-eye"></i> View
                  </button>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Remarks</th>
              <td mat-cell *matCellDef="let el"> {{el.remarks}} </td>
            </ng-container>
            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let el">
                <!--<ng-container *ngIf="el.status === 'Approved' && el.toDate > el.currentDate">
    <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm">
      <i class="fa fa-plus"></i> Create Event
    </button><br />
  </ng-container>-->
                <!--commented by rp-->
                <!--<ng-container *ngIf="el.status === 'Approved' && el.toDate >= el.currentDate">
    <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Create Event</button><br />
  </ng-container>
  <ng-container *ngIf="el.status === 'Rejected for Query' || el.status === 'Pending';">
    <button (click)="redirectToProposalPage(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="bi bi-pencil"></i> Edit</button><br />
  </ng-container>
  <ng-container *ngIf="el.status === 'Approved' && el.toDate < el.currentDate">
    <span class="spn-order">Work Order Date Expire</span><br />
  </ng-container>-->
                <!--rp ends-->
                <!--added by rp-->
                <ng-container *ngIf="el.status === 'Approved' && el.toDate > el.currentDate && el.eventStatus == '0'">
                  <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm" [disabled]="isDisabled">
                    <i class="fa fa-plus"></i> Create Event
                  </button><br />
                </ng-container>
                <ng-container *ngIf="el.status === 'Approved' && el.toDate >= el.currentDate && el.eventStatus == '1'">
                  <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Create Event</button><br />
                </ng-container>
                <ng-container *ngIf="el.status === 'Rejected for Query' || el.status === 'Pending';">
                  <button (click)="redirectToProposalPage(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="bi bi-pencil"></i> Edit</button><br />
                </ng-container>
                <ng-container *ngIf="el.status === 'Approved' && el.toDate < el.currentDate && el.eventStatus == '1'">
                  <span class="spn-order">Work Order Date Expire</span><br />
                </ng-container>
                <!--rp ends-->
                <!--<ng-container *ngIf="el.status === 'Approved' && el.toDate > el.currentDate && el.eventStatus == '0'">
  <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm">-->
                <!--[disabled]="isDisabled"-->
                <!--<i class="fa fa-plus"></i> Create Event
    </button><br />
  </ng-container>
  <ng-container *ngIf="el.status === 'Approved' && el.toDate >= el.currentDate && el.eventStatus == '1'">
    <button (click)="onCreateEvent(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Create Event</button><br />
  </ng-container>
  <ng-container *ngIf="el.status === 'Rejected for Query' || el.status === 'Pending';">
    <button (click)="redirectToProposalPage(el.proposalUserId)" class="btn btn-primary btn-sm"><i class="bi bi-pencil"></i> Edit</button><br />
  </ng-container>
  <ng-container *ngIf="el.status === 'Approved' && el.toDate < el.currentDate && el.eventStatus == '1'">
    <span class="spn-order">Work Order Date Expire</span><br />
  </ng-container>-->
              </td>
            </ng-container>
            <ng-container matColumnDef="Download">
              <th mat-header-cell *matHeaderCellDef>Work Order Download</th>
              <td mat-cell *matCellDef="let el">
                <a class="text-decoration-none btn btn-warning btn-sm mt-1" *ngIf="el.documentPath"
                   (click)="onDownload(el.documentPath, el.documentName); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
                  <i class="bi bi-download"></i> Download
                </a>
                <button class="btn btn-primary btn-sm mt-1" *ngIf="el.documentPath" (click)="openFilePreviewDialog(el.documentPath, el.documentName)"> <i class="bi bi-eye"></i> View File</button>
              </td>
            </ng-container>
            <ng-container matColumnDef="Proposal">
              <th mat-header-cell *matHeaderCellDef>Proposal Download</th>
              <td mat-cell *matCellDef="let el">
                <a class="text-decoration-none btn btn-warning btn-sm" *ngIf="el.uploadProposalPath"
                   (click)="onDownload(el.uploadProposalPath, el.uploadProposalDocument); $event.preventDefault()" style="text-decoration: underline; cursor: pointer">
                  <i class="bi bi-download"></i> Download
                </a>
                <button *ngIf="el.uploadProposalPath" class="btn btn-primary btn-sm mt-1" (click)="openFilePreviewDialog(el.uploadProposalPath, el.uploadProposalDocument)"> <i class="bi bi-eye"></i> View File</button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            Row shown when there is no matching data.
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
          </table>
        </div>
        <mat-paginator #paginator
                       class="demo-paginator"
                       (page)="onPageChange($event)"
                       [length]="length"
                       [pageSize]="pageSize"
                       [showFirstLastButtons]="showFirstLastButtons"
                       [pageSizeOptions]="pageSizeOptions"
                       [hidePageSize]="hidePageSize"
                       [pageIndex]="pageIndex"
                       aria-label="Select page">
        </mat-paginator>
      </div>

    </form>
  </div>
</div>
